export const getUserData = (state) => state?.user?.data || []; 